import {
  createTableColumn,
  Link,
  TableColumnDefinition,
} from "@fluentui/react-components";
import i18n from "i18next";
import { ITeamDto } from "../../../Models/ITeamDto";

interface IMyTeamsColumns {
  onSelectTeam(Team: ITeamDto): void;
  onNavigate(item: string): void;
}

export function MyTeamsColumns(props: IMyTeamsColumns) {
  const columns: TableColumnDefinition<ITeamDto>[] = [
    createTableColumn<ITeamDto>({
      columnId: "Teamname",
      compare: (a, b) => {
        if (a.teamname && b.teamname) {
          return a.teamname.localeCompare(b.teamname);
        } else return 0;
      },
      renderHeaderCell: () => {
        return "Teamname";
      },
      renderCell: (item: ITeamDto) => {
        return (
          <Link onClick={() => props.onNavigate(item.teamId)}>
            {item.teamname}
          </Link>
        );
      },
    }),
    createTableColumn<ITeamDto>({
      columnId: "Mitglieder",
      compare: (a, b) => {
        if (a.members.length && b.members.length) {
          return a.members.length - b.members.length;
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("members");
      },
      renderCell: (item) => {
        return <div>{item.members.length}</div>;
      },
    }),
    createTableColumn<ITeamDto>({
      columnId: "Ersteller",
      compare: (a, b) => {
        if (a.ownerDto.fullName && b.ownerDto.fullName) {
          return a.ownerDto.fullName.localeCompare(b.ownerDto.fullName);
        } else return 0;
      },
      renderHeaderCell: () => {
        return "Ersteller";
      },
      renderCell: (item) => {
        var creator = item.ownerDto.fullName;
        return <div>{creator}</div>;
      },
    }),
  ];
  return columns;
}
